// QuantTechGrid Logo Component
// Uses the official PNG logo with transparent background

export const QuantTechGridLogo = ({ className = "" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/qtg-logo.png"
        alt="QuantTechGrid"
        className="h-8 md:h-9 w-auto dark:invert-0 invert"
        data-testid="logo-image"
      />
    </div>
  );
};

// Icon-only version (same image, smaller)
export const QuantTechGridIcon = ({ className = "h-8" }) => {
  return (
    <img
      src="/qtg-logo.png"
      alt="QuantTechGrid"
      className={`w-auto dark:invert-0 invert ${className}`}
    />
  );
};

export default QuantTechGridLogo;
